import React from "react";
import AdminEntityList from "@/components/admin/AdminEntityList";

const fields = [
  { key: "name", label: "Name", required: true },
  { key: "slug", label: "Slug (auto if empty)" },
  { key: "definition", label: "Definition", type: "textarea", rows: 3 },
  { key: "description", label: "Longer description", type: "textarea", rows: 4 },
];

export default function AdminTopics() {
  return <AdminEntityList title="Topics" endpoint="/admin/topics" listEndpoint="/topics" fields={fields} testIdBase="admin-topics" />;
}
